import Vue from 'vue';
import { BREAKPOINTS } from '@/constants';

/**
 * Реактивный объект с размерами viewport
 *
 * @returns {CombinedVueInstance<Object>}
 */
export const viewportSize = new Vue({
  data: () => ({
    width: 0,
    height: 0,
  }),

  computed: {
    size() {
      return {
        width: this.width,
        height: this.height,
      };
    },
  },

  created() {
    this.init();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateSize);
  },

  methods: {
    async init() {
      await this.$nextTick();
      window.addEventListener('resize', this.updateSize);
      this.updateSize();
    },

    updateSize() {
      this.width = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;
      this.height = window.innerHeight
        || document.documentElement.clientHeight
        || document.body.clientHeight;
    },
  },
});

/**
 * ...
 *
 * @type {CombinedVueInstance<Object>}
 */
export const mediaQueries = new Vue({
  data: () => ({
    breakpoints: [
      { name: BREAKPOINTS.XS, minWidth: 0, maxWidth: 767 },
      { name: BREAKPOINTS.SM, minWidth: 768, maxWidth: 991 },
      { name: BREAKPOINTS.MD, minWidth: 992, maxWidth: 1199 },
      { name: BREAKPOINTS.LG, minWidth: 1200, maxWidth: 9999 },
    ],
    lastBreakpoint: '',
  }),

  computed: {
    width() {
      return viewportSize.width;
    },
    breakpoint() {
      return this.breakpoints.find((element) => (
        this.width >= element.minWidth && this.width <= element.maxWidth
      )).name;
    },
  },

  watch: {
    breakpoint: {
      handler(value, oldValue) {
        this.lastBreakpoint = oldValue;
      },
    },
  },
});
